export default "__VITE_ASSET__Bik7$z4___"